module.exports = __webpack_public_path__ + "static/media/办公楼楼宇智能化管理2.60a631a3.jpg";